import React from "react";

const Policy = () => {
  const headingClass = "text-3xl md:text-4xl font-bold mb-6 text-[#1B86F8]";
  const sectionTitleClass = "text-2xl md:text-3xl font-extrabold mt-10 mb-4 text-[#29446b]";
  const subLabelClass = "mb-2 text-lg md:text-xl font-bold text-[#1B86F8]";
  const paragraphClass = "mb-5 text-[#333] leading-relaxed text-base md:text-lg";
  const listClass = "list-disc pr-6 mb-6 text-base md:text-lg text-[#333]";

  return (
    <div className="bg-zinc-100 min-h-screen py-12">
      <div
        className="max-w-5xl mx-auto px-6 py-12 bg-white shadow-2xl border border-gray-200 rounded-2xl text-right"
        dir="rtl"
        style={{ fontSize: "18px", lineHeight: "1.75" }}
      >
        <h1 className={headingClass}>
          سياسة الخصوصية
        </h1>
        <p className="mb-6 text-sm text-[#909090]">
          تاريخ النفاذ: 27 مايو 2025
        </p>

        <p className={paragraphClass}>
          تلتزم منصة masark.co ("نحن" أو "لنا" أو "منصتنا") بحماية خصوصيتك والتعامل مع معلوماتك الشخصية بشفافية واهتمام.
          توضح سياسة الخصوصية هذه كيفية جمعنا واستخدامنا والإفصاح عن وحماية معلوماتك عند استخدامك لموقعنا الإلكتروني ومنصة الدورات التدريبية عبر الإنترنت.
        </p>
        <p className={paragraphClass}>
          بدخولك أو استخدامك لمنصة masark.co، فإنك توافق على سياسة الخصوصية هذه.
          إذا كنت لا توافق على ممارساتنا، يرجى عدم استخدام خدماتنا.
        </p>

        <section>
          <h2 className={sectionTitleClass}>1. المعلومات التي نقوم بجمعها</h2>

          <p className={subLabelClass}>أ. المعلومات الشخصية التي تقدمها لنا</p>
          <ul className={listClass}>
            <li>الاسم</li>
            <li>عنوان البريد الإلكتروني</li>
            <li>رقم الهاتف</li>
            <li>معلومات الدفع (تتم معالجتها بشكل آمن عبر مزودي خدمة خارجيين)</li>
            <li>صورة الملف الشخصي</li>
            <li>بيانات تسجيل الدخول (اسم المستخدم وكلمة المرور)</li>
            <li>أي معلومات أخرى تقدمها عند التسجيل أو الاشتراك في الدورات أو التواصل معنا</li>
          </ul>

          <p className={subLabelClass}>ب. المعلومات التي نجمعها تلقائيًا</p>
          <ul className={listClass}>
            <li>عنوان بروتوكول الإنترنت (IP)</li>
            <li>نوع الجهاز والمتصفح</li>
            <li>نظام التشغيل</li>
            <li>بيانات الاستخدام (الصفحات التي تمت زيارتها، الإجراءات التي تم اتخاذها، تاريخ ووقت الزيارة)</li>
            <li>الموقع الإلكتروني المُحيل</li>
            <li>ملفات السجل وبيانات التحليلات</li>
          </ul>

          <p className={subLabelClass}>ج. المعلومات من أطراف ثالثة</p>
          <ul className={listClass}>
            <li>مزودي خدمات الدفع</li>
            <li>مزودي خدمات التحليلات</li>
            <li>منصات التواصل الاجتماعي (إذا قمت بربط حسابك)</li>
            <li>مصادر متاحة للجمهور، حسب ما يسمح به القانون</li>
          </ul>
        </section>

        <section>
          <h2 className={sectionTitleClass}>2. الأساس القانوني لمعالجة البيانات (GDPR)</h2>
          <p className={paragraphClass}>
            إذا كنت متواجدًا في المنطقة الاقتصادية الأوروبية (EEA)، فإننا نعالج بياناتك الشخصية استنادًا إلى الأسس القانونية التالية:
          </p>
          <ul className={listClass}>
            <li>الموافقة: عندما تمنحنا إذنًا صريحًا</li>
            <li>العقد: عندما تكون المعالجة ضرورية لتنفيذ عقد معك</li>
            <li>الالتزام القانوني: عندما تكون المعالجة مطلوبة بموجب القانون</li>
            <li>المصلحة المشروعة: لأغراض مثل تحسين خدماتنا، بشرط ألا تتعارض مع حقوقك</li>
          </ul>
        </section>

        <section>
          <h2 className={sectionTitleClass}>3. كيف نستخدم معلوماتك</h2>
          <p className={paragraphClass}>نستخدم معلوماتك من أجل:</p>
          <ul className={listClass}>
            <li>توفير وتشغيل وصيانة منصتنا وخدماتنا</li>
            <li>إنشاء وإدارة حسابك</li>
            <li>تقديم محتوى الدورات وتتبع تقدمك</li>
            <li>معالجة المدفوعات وتنفيذ الطلبات</li>
            <li>التواصل معك (التحديثات، الدعم، الرسائل التسويقية والمعاملات)</li>
            <li>تخصيص تجربتك التعليمية</li>
            <li>تحليل الاستخدام وتحسين موقعنا وخدماتنا</li>
            <li>منع الاحتيال، وتطبيق شروط الخدمة، والامتثال للالتزامات القانونية</li>
          </ul>
        </section>

        <section>
          <h2 className={sectionTitleClass}>4. كيف نشارك معلوماتك</h2>
          <p className={paragraphClass}>قد نشارك معلوماتك مع:</p>
          <ul className={listClass}>
            <li>مزودي الخدمات: لمعالجة المدفوعات، الاستضافة، التحليلات، ودعم العملاء</li>
            <li>المدربين: إذا قمت بالاشتراك في دورة، قد تتم مشاركة معلوماتك ذات الصلة مع المدرب</li>
            <li>السلطات القانونية: إذا تطلب القانون ذلك أو لحماية حقوقنا أو حقوق المستخدمين</li>
            <li>نقل الأعمال: في حالة الاندماج أو الاستحواذ أو بيع الأصول</li>
            <li>بموافقتك: عندما تمنحنا إذنًا صريحًا</li>
          </ul>
          <p className="mb-6 font-semibold text-gray-700">
            نحن لا نبيع معلوماتك الشخصية لأطراف ثالثة.
          </p>
        </section>

        <section>
          <h2 className={sectionTitleClass}>5. نقل البيانات دوليًا</h2>
          <p className={paragraphClass}>
            قد يتم نقل معلوماتك ومعالجتها في دول خارج بلدك، بما في ذلك دول قد لا توفر نفس مستوى حماية البيانات.
            عند نقل بياناتك الشخصية دوليًا، نتخذ التدابير اللازمة لضمان حمايتها، مثل استخدام البنود التعاقدية القياسية المعتمدة من المفوضية الأوروبية أو وسائل حماية مناسبة أخرى.
          </p>
        </section>

        <section>
          <h2 className={sectionTitleClass}>6. ملفات تعريف الارتباط والتقنيات المشابهة</h2>
          <p className={paragraphClass}>نستخدم ملفات تعريف الارتباط (Cookies) والتقنيات المشابهة من أجل:</p>
          <ul className={listClass}>
            <li>التعرف عليك وتذكر تفضيلاتك</li>
            <li>تحليل استخدام الموقع وأدائه</li>
            <li>تقديم محتوى وإعلانات مخصصة</li>
          </ul>
          <p className={paragraphClass}>
            يمكنك إدارة تفضيلات ملفات تعريف الارتباط من خلال إعدادات متصفحك. لمزيد من التفاصيل، يرجى مراجعة سياسة ملفات تعريف الارتباط.
          </p>
        </section>

        <section>
          <h2 className={sectionTitleClass}>7. أمان البيانات</h2>
          <p className={paragraphClass}>
            نطبق تدابير تقنية وتنظيمية مناسبة لحماية معلوماتك الشخصية من الوصول أو الاستخدام أو الإفصاح أو التغيير أو الإتلاف غير المصرح به.
            ومع ذلك، لا توجد طريقة نقل عبر الإنترنت أو تخزين إلكتروني آمنة بنسبة 100%.
          </p>
        </section>

        <section>
          <h2 className={sectionTitleClass}>8. الاحتفاظ بالبيانات</h2>
          <p className={paragraphClass}>
            نحتفظ بمعلوماتك الشخصية فقط للمدة اللازمة لتحقيق الأغراض التي جُمعت من أجلها، بما في ذلك المتطلبات القانونية أو المحاسبية أو التنظيمية.
            عند عدم الحاجة لمعلوماتك، سنقوم بحذفها أو إخفائها بشكل آمن.
          </p>
        </section>

        <section>
          <h2 className={sectionTitleClass}>9. حقوقك</h2>
          <p className={paragraphClass}>
            اعتمادًا على موقعك الجغرافي، قد يكون لك الحق في:
          </p>
          <ul className={listClass}>
            <li>الوصول: طلب نسخة من معلوماتك الشخصية</li>
            <li>التصحيح: تصحيح المعلومات غير الدقيقة أو غير الكاملة</li>
            <li>الحذف: طلب حذف بياناتك ("الحق في النسيان")</li>
            <li>تقييد المعالجة: طلب تقييد معالجة بياناتك</li>
            <li>الاعتراض: الاعتراض على أنواع معينة من المعالجة، بما في ذلك التسويق المباشر</li>
            <li>قابلية النقل: طلب نقل بياناتك إلى مزود خدمة آخر</li>
            <li>سحب الموافقة: سحب الموافقة في أي وقت إذا كانت المعالجة تعتمد على الموافقة</li>
          </ul>
          <p className={paragraphClass}>
            لممارسة حقوقك، يرجى الاتصال بنا عبر معلومات الاتصال أدناه.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Policy;



